import type { Metadata } from "next";
import { CompatTool } from "@/components/compat-tool";

export const metadata: Metadata = {
  title: "Hợp Tuổi Kết Hôn — Tử Vi Số",
  description: "Xem hợp tuổi vợ chồng theo Thiên Can, Địa Chi, Ngũ Hành Mệnh, Cung Phi.",
};

type Props = { searchParams: Promise<{ y1?: string; g1?: string; y2?: string; g2?: string }> };

export default async function HopTuoiKuta({ searchParams }: Props) {
  const sp = await searchParams;
  return (
    <CompatTool
      searchParams={sp}
      mode="marriage"
      title="Hợp Tuổi Kết Hôn"
      hint="Phân tích hợp tuổi vợ chồng — Thiên Can, Địa Chi, Ngũ Hành, Cung Phi."
    />
  );
}
